let load = require('./helpers/browser/esm-js-loader-shards')(4);
module.exports = Promise.all([load("fliVL"), load("3o8b3")]).then(() => parcelRequire('8Xvm1'));